import { LoadingOutlined } from '@ant-design/icons';

import { Form, Input, Spin } from 'antd';
import React, { useState } from 'react';

import { signUpNewsletter } from '_utils/apis';

export default function NewsletterForm() {
  const [showSuccessForm, setShowSuccessForm] = useState(false);
  const [busy, setBusy] = useState(false);

  const onFinish = async (values) => {
    const formValues = {
      full_name: values.full_name,
      email: values.email,
    };
    setBusy(true);

    try {
      const res = await signUpNewsletter(formValues);
      if (res.data.result === 'Success') {
        setShowSuccessForm(true);
      } else {
        console.log(res, 'res');
      }
    } catch (e) {
      console.log(e);
    } finally {
      setBusy(false);
    }
  };

  if (showSuccessForm) {
    return (
      <div className="text-center text-xl font-bold">
        Thank you for subscribing to our newsletter!
      </div>
    );
  }

  return (
    <Form onFinish={onFinish}>
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        spinning={busy}
      >
        <div className="flex flex-col xl:flex-row justify-between" id="signupnews">
          <div>
            <h4 className="text-base font-semibold mb-0 leading-6 text-center md:text-left">
              Subscribe to our newsletter
            </h4>
            <p className="mb-0 text-base leading-6 text-content-secondary text-center md:text-left mt-1 xl:mt-0">
              Car tips, articles and resources, sent to your inbox bi-monthly.
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-0 md:gap-3 items-center mt-4 xl:mt-0">
            <Form.Item
              rules={[
                {
                  required: true,
                  message: 'Please input Full Name!',
                },
              ]}
              name="full_name"
              className="w-full lg:w-[300px] mb-0"
            >
              <Input
                placeholder="Enter your name"
                className="h-12"
                size="large"
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: 'Please input Email!',
                },
                {
                  type: 'email',
                  message: 'Please enter a valid email address.',
                },
              ]}
              name="email"
              className="w-full lg:w-[300px] mb-0"
            >
              <Input
                placeholder="Enter your email"
                className="h-12"
                size="large"
              />
            </Form.Item>
            <Form.Item className="w-full lg:w-auto">
              <button
                type="submit"
                className="bg-caroured50 text-white font-bold text-base leading-6 py-3 px-5 rounded h-12 hover:opacity-80 w-full"
              >
                Subscribe
              </button>
            </Form.Item>
          </div>
        </div>
      </Spin>
    </Form>
  );
}
